export default __webpack_public_path__ + "static/media/check.c953651a.svg";